/**
 * The 8px ember dot that means "there is something here you have not seen" (spec §5B, §5C).
 *
 * Extracted so the announcement eyebrow and the event card render the same mark rather than two
 * that drift. Placement belongs to the caller — the spec puts it before the eyebrow on an
 * announcement and at the top-right of an event card — so this component takes no positioning.
 *
 * Its **presence** is the signal, not its colour, so it satisfies the never-colour-alone rule the
 * rest of the system holds to. `count` only enriches the label for screen readers; the dot is the
 * same size whatever the number, because "how many" is not the question a glance is asking.
 */
export function UnreadDot({ count }: { count?: number }) {
  return (
    <span
      role="status"
      aria-label={count && count > 0 ? `${count} unread` : 'Unread'}
      style={{
        width: 8,
        height: 8,
        borderRadius: 'var(--radius-full)',
        background: 'var(--color-accent-announcement)',
        display: 'inline-block',
        flexShrink: 0,
      }}
    />
  );
}
